/**
 * Public root route (APP-001 §6).
 *
 * Sends signed-out visitors to sign-in and signed-in visitors to the
 * dashboard. The marketing site is the separate Webflow surface; this is the
 * authenticated application root only.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { LoadingState } from '@/components/feedback/LoadingState';
import { parseReturnIntent } from '@/auth/returnPath';

export function RootRoute() {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();
  if (!isLoaded) return <LoadingState label="Loading…" />;
  if (isSignedIn) return <Navigate to="/dashboard" replace />;
  const intent = parseReturnIntent(location.search);
  const params = intent.returnPath ? new URLSearchParams({ redirect: intent.returnPath }) : new URLSearchParams();
  const qs = params.toString();
  return <Navigate to={qs ? `/sign-in?${qs}` : '/sign-in'} replace />;
}
